
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import headers from './endOfDayHeaders';
import { Receipt } from '@/interfaces/models/Receipt';

@Component
export default class EndOfDayReceiptTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Receipt[];

  public expanded: string[] = [];

  get tableHeaders() {
    return headers.map((h: ColumnHeader) => ({ ...h, text: this.$t(h.text) }));
  }
}
